<template>
  <section>
    <div class="body-of-child">
      <div>
        <div class="row m-0">
          <div class="my-5">
            <div class="mt-5">
              <h4 class="mb-0">
                {{ $t('message.staticPages.imprint.title1') }}
              </h4>
              <hr
                align="left"
                class="mt-2">
            </div>
            <div class="row">
              <div class="col-md-12">
                <!-- eslint-disable vue/no-v-html -->
                <p v-html="$t('message.staticPages.imprint.text1')" />
                <!-- eslint-enable vue/no-v-html -->
              </div>
            </div>
            <div>
              <h4 class="mb-0">
                {{ $t('message.staticPages.imprint.title2') }}
              </h4>
              <hr
                align="left"
                class="mt-2">
            </div>
            <div class="row">
              <div class="col-md-12">
                <!-- eslint-disable vue/no-v-html -->
                <p v-html="$t('message.staticPages.imprint.text2')" />
                <!-- eslint-enable vue/no-v-html -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <coozzy-footer />
  </section>
</template>

<script>

import { language } from '../mixins/language'

export default {
  name: 'ImprintView',
  mixins: [language]
}
</script>

<style lang="scss" scoped>
  .body-of-child {
    background-color: $color-text-white;
    min-height: 90vh;
    padding-bottom: 226px;
  }
  hr {
    border: 1px solid $color-primary-dark;
    width: 30px;
  }
  p a {
    color: $color-primary-dark;
  }
  h4 {
    line-height: 29px;
    font-weight: 300;
    font-size: 23px;
    color: $color-text-grey;
  }
  :deep(footer) {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030;
  }
</style>
